import ChatScreenShotWebp from "../../../assets/images/chat-screenshot.webp"
import ChatScreenShotPng from "../../../assets/images/chat-screenshot.png"
import PopUpNotification from "../pop-up-notification"
import { ENGAGE_LINK } from "../../constants"

const SendSmsPopup = () => (
  <PopUpNotification id="notification">
    <div className="relative text-center pt-2.5 bg-[#E6F4F3]">
      <div className="absolute top-[53px] -left-6 transform -rotate-45 origin-top-left">
        <div className="bg-violet-500 text-white text-sm h-[22px] w-28 leading-[22px]">
          NEW
        </div>
      </div>

      <picture>
        <source srcSet={ChatScreenShotWebp} type="image/webp" />
        <img
          className="w-[105px] inline-block"
          src={ChatScreenShotPng}
          alt="Chat screenshot"
        />
      </picture>
    </div>

    <h2 className="text-lg font-semibold text-base-dark m-0 py-4 px-6">
      Send SMS Instant Quote to Any CRM Lead.{" "}
      <a
        className="text-primary-400 hover:text-primary-500 border-b border-dashed border-primary-400 hover:border-primary-500 pb-px"
        target="_blank"
        rel="noreferrer"
        href={ENGAGE_LINK}
      >
        Learn more
      </a>
    </h2>
  </PopUpNotification>
)

export default SendSmsPopup
